import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LinkDarkButton from '../components/LinkDarkButton'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Slide from '@material-ui/core/Slide'
import { injectIntl } from 'react-intl'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { nextSurveySelector } from '../redux/selectors'
import { Paper } from '@material-ui/core'

const ExternalAuthHeader = ({ intl }) => {
	return (
		<Paper
			data-testid='external-auth-header'
			position='fixed' style={{ background: '#FF8556' }} square={true}>
			<Slide direction='down' in={true} mountOnEnter unmountOnExit>
				<Toolbar style={{ margin: '0 auto' }}>
					<Grid container direction='column' style={{ padding: '10px 0px' }}>
						<Grid item style={{ textAlign: 'center' }}>
							<Typography
								style={{
									color: 'white',
									fontSize: '16px'
								}}>
								{intl.formatMessage({
									id: 'app.dashboard.externalAuthHeader'
								}).toUpperCase()}
							</Typography>
						</Grid>
					</Grid>
				</Toolbar>
			</Slide>
		</Paper>
	)
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(ExternalAuthHeader)
